// extracted by mini-css-extract-plugin
export default {"wrapper":"DropdownTextLinkItem-module--wrapper--369ad","textLink":"DropdownTextLinkItem-module--textLink--b512b typography-module--link--06a20"};